import styled from '@emotion/styled';

const ScreenContentWrapper = styled('main')({
  flex: 1
});

export default ScreenContentWrapper;
